import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'
import { COLUMN_BYTES } from '../../../lib/columnBytes'

/** DB kolon tanımıyla birebir uzunluk sınırı (059 spec FR-033). */
export const GROUP_NAME_MAX_LEN = 1000

/**
 * Parametre Grubu form şeması (059 US5). TR ad zorunlu, EN ad opsiyonel ve **boşaltılabilir**.
 *
 * **Ad tekilliği doğrulanmaz** — tabloda benzersizlik indeksi yoktur ve uygulama olmayan bir kısıtı
 * uydurmaz (045 kararı; spec Assumptions).
 */
export const templateParamGroupFormSchema = z.object({
  nameTr: requiredText(GROUP_NAME_MAX_LEN, COLUMN_BYTES.referenceText),
  nameEn: optionalText(GROUP_NAME_MAX_LEN, COLUMN_BYTES.referenceText),
})

export type TemplateParamGroupFormValues = z.infer<typeof templateParamGroupFormSchema>
